import { ReactNode } from "react";
import { useLegacyNavigationModel } from "@/navigation/pageRegistry/useLegacyNavigationModel";
import { LoggedUserContext } from "./LoggedUserContext";

interface LoggedUserProviderProps {
  children: ReactNode;
}

export function LoggedUserProvider({ children }: LoggedUserProviderProps) {
  const { activePages, sideBarItens, avatarMenuItens } =
    useLegacyNavigationModel();

  const contextValue = {
    // Mantido temporariamente para compatibilidade do contrato do contexto.
    // A página atual agora é resolvida em `src/navigation/LegacyDynamicPageRouter.tsx`.
    CurrentPage: () => null,
    activePages,
    sideBarItens,
    avatarMenuItens,
  };

  return (
    <LoggedUserContext.Provider value={contextValue}>
      {children}
    </LoggedUserContext.Provider>
  );
}
